<script setup>
import BarberItems from '@/components/Popups/BarberItemsPopup.vue';
import { useAuthStore } from '@/stores/authStore';
import { useProductStore } from '@/stores/productsStore';
import { computed } from 'vue';

const authStore = useAuthStore();
const productStore = useProductStore();

// Reactive specialized group names
const names = computed(() =>
  (productStore.spcializedItems || []).map(item => item.Name)
);

console.log('Specialized Item Names:', names.value);

function openSpecializedGroup(name) {
  productStore.selectedSpecializedGroup = name;
  authStore.isBarberItemsPopupVisible = true;
}

</script>

<template>

    <button
      v-for="item in names"
      :key="item"
      @click="() => openSpecializedGroup(item)"
      class="bg-white w-1/2 text-center p-5 rounded-2xl flex gap-5 my-3"
    >
      <span class="cursor-pointer flex items-center gap-10">
        <i
          class="pi pi-bars text-purple-500 bg-purple-100 p-4 rounded-full"
          style="font-size: 1.875rem;"
        ></i>
        <span class="font-semibold">{{ item }}</span>
      </span>
    </button>
    <BarberItems />
</template>

<style scoped>
</style>
